import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 24 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, description, className = "" }) => (
  <Reveal className={`max-w-2xl ${className}`}>
    {eyebrow && (
      <div className="flex items-center gap-3 mb-4">
        <span className="gold-dot" />
        <span className="text-xs uppercase tracking-widest text-primary font-medium">
          {eyebrow}
        </span>
      </div>
    )}
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-foreground">
      {title}
    </h2>
    {description && (
      <p className="mt-4 text-sm sm:text-base leading-relaxed text-muted-foreground">
        {description}
      </p>
    )}
  </Reveal>
);
